import { useEffect } from 'react';

const DOMAIN = 'https://thebreezmedia.com';
const OG_IMAGE = 'https://thebreezmedia.com/og-image.png';

function setMeta(attr, key, content) {
  let el = document.querySelector(`meta[${attr}="${key}"]`);
  if (!el) {
    el = document.createElement('meta');
    el.setAttribute(attr, key);
    document.head.appendChild(el);
  }
  el.setAttribute('content', content);
}

export const SEO = ({ title, description, path = '', type = 'website', schema }) => {
  const url = `${DOMAIN}${path}`;
  const fullTitle = path === '/' || path === ''
    ? 'The Breez Media | Digital Growth Agency - Marketing, Branding, AI & Technology'
    : title.includes('|') || title.includes(':') ? title : `${title} | The Breez Media`;

  useEffect(() => {
    document.title = fullTitle;

    // Description
    setMeta('name', 'description', description);
    setMeta('name', 'robots', 'index, follow');

    // Canonical
    let canonical = document.querySelector('link[rel="canonical"]');
    if (!canonical) {
      canonical = document.createElement('link');
      canonical.setAttribute('rel', 'canonical');
      document.head.appendChild(canonical);
    }
    canonical.setAttribute('href', url);

    // Open Graph
    setMeta('property', 'og:type', type);
    setMeta('property', 'og:url', url);
    setMeta('property', 'og:title', fullTitle);
    setMeta('property', 'og:description', description);
    setMeta('property', 'og:image', OG_IMAGE);
    setMeta('property', 'og:image:width', '1080');
    setMeta('property', 'og:image:height', '1080');
    setMeta('property', 'og:site_name', 'The Breez Media');
    setMeta('property', 'og:locale', 'en_US');

    // Twitter
    setMeta('name', 'twitter:card', 'summary_large_image');
    setMeta('name', 'twitter:title', fullTitle);
    setMeta('name', 'twitter:description', description);
    setMeta('name', 'twitter:image', OG_IMAGE);

    // JSON-LD
    if (schema) {
      let ld = document.getElementById('breez-jsonld');
      if (!ld) {
        ld = document.createElement('script');
        ld.id = 'breez-jsonld';
        ld.type = 'application/ld+json';
        document.head.appendChild(ld);
      }
      ld.textContent = JSON.stringify(schema);
    }
  }, [fullTitle, description, url, type, schema]);

  return null;
};
